import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconAbout(props: IconContainerProps) {
    return <IconContainer {...props}>
        info
    </IconContainer>
}